import AddIcon from '@mui/icons-material/Add';
import BlockIcon from '@mui/icons-material/Block';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import ExtensionIcon from '@mui/icons-material/Extension';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import FilterListIcon from '@mui/icons-material/FilterList';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import RestoreIcon from '@mui/icons-material/Restore';
import SearchIcon from '@mui/icons-material/Search';
import StopIcon from '@mui/icons-material/Stop';
import SyncIcon from '@mui/icons-material/Sync';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// Registro deliberadamente acotado. Los nombres incluidos aqui forman parte
// del contrato publico de los plugins y evitan empaquetar el catalogo completo
// de @mui/icons-material en el bundle principal.
export const PLUGIN_ICONS = Object.freeze({
  Add: AddIcon,
  Block: BlockIcon,
  Close: CloseIcon,
  CloudDownload: CloudDownloadIcon,
  ContactPhone: ContactPhoneIcon,
  DeleteOutline: DeleteOutlineIcon,
  Download: DownloadIcon,
  Extension: ExtensionIcon,
  FiberManualRecord: FiberManualRecordIcon,
  FilterList: FilterListIcon,
  OpenInNew: OpenInNewIcon,
  Pause: PauseIcon,
  PlayArrow: PlayArrowIcon,
  Refresh: RefreshIcon,
  Replay: ReplayIcon,
  Restore: RestoreIcon,
  Search: SearchIcon,
  Stop: StopIcon,
  Sync: SyncIcon,
  ViewColumn: ViewColumnIcon,
  WhatsApp: WhatsAppIcon
});

export const getPluginIcon = (name) => PLUGIN_ICONS[name] || ExtensionIcon;
